import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';

export const techdocsTranslation = TranslationBlueprint.make({
  name: 'techdocs',
  params: {
    resource: createTranslationMessages({
      ref: techdocsTranslationRef,
      full: false,
      messages: {
        'aboutCard.viewTechdocs': 'Documentatie bekijken',
        'buildLogs.title': 'Builddetails',
        'buildLogs.closeDrawer': 'Sluit het paneel',
        'buildLogs.showBuildLogs': 'Toon buildlogs',
        'buildLogs.waitingForLogs': 'Wachten op logs...',
        'stateIndicator.initialBuild.message':
          'Deze documentatie wordt voor het eerst geopend en wordt nu voorbereid. Daarna laadt ze veel sneller.',
        'stateIndicator.contentStaleRefreshing.message':
          'Er wordt een nieuwere versie van deze documentatie voorbereid. Die is binnenkort beschikbaar.',
        'stateIndicator.contentStaleReady.message':
          'Er is een nieuwere versie van deze documentatie beschikbaar. Ververs de pagina om die te bekijken.',
        'stateIndicator.contentStaleReady.refreshButton': 'Ververs',
        'stateIndicator.contentStaleError.message':
          'Het bouwen van een nieuwere versie van deze documentatie is mislukt.',
        'redirectNotification.redirectNow': 'Nu doorsturen',
        'search.noResults': 'Geen resultaten gevonden',
        'search.placeholder': 'Zoek in documentatie van {{entityTitle}}',
        'readerPageHeader.owner': 'Eigenaar',
        'readerPageHeader.lifecycle': 'Levenscyclus',
        'readerPageHeader.source': 'Bron',
        'home.supportButton': 'Ontdek de documentatie in je omgeving.',
        'pageWrapper.title': 'Documentatie',
        'pageWrapper.subtitle': 'Documentatie beschikbaar bij {{orgName}}',
        'table.columns.document': 'Document',
        'table.columns.owner': 'Eigenaar',
        'table.columns.kind': 'Soort',
        'table.columns.type': 'Type',
        'table.header.actions': 'Acties',
        'table.toolbar.searchPlaceholder': 'Filter',
        'table.pagination.labelRowsSelect': 'rijen',
        'table.body.emptyDataSourceMessage': 'Geen gegevens om te tonen',
        'table.actions.copyDocsUrl':
          'Klik om de link naar de documentatie naar het klembord te kopiëren',
        'table.actions.addToFavorites': 'Voeg toe aan favorieten',
        'table.actions.removeFromFavorites': 'Verwijder uit favorieten',
        'table.emptyState.title': 'Geen documenten om te tonen',
        'table.emptyState.description':
          'Maak je eigen document. Bekijk onze informatie om te beginnen.',
        'table.emptyState.docsButton': 'Documentatie',
        'table.title.all': 'Alle',
        'error.couldNotLoad':
          'De beschikbare documentatie kon niet worden geladen.',
        'nav.title': 'Documentatie',
        'entityContent.title': 'Documentatie',
        'reader.settings': 'Instellingen',
      },
    }),
  },
});
